/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { IMAGE_SERVICE_URL } from 'app/config';

export const getImageUrl = (baseUrl: string, imageUrl: string): string => {
  return baseUrl.indexOf('localhost') === -1
    ? `${IMAGE_SERVICE_URL}/unsafe/filters:quality(90)/${baseUrl}${imageUrl}`
    : imageUrl;
};
